// import React, { useEffect, useState } from "react";
// import { courseService } from "../../services/api";
// import ItemGrid from '../common/ItemGrid';
// import ItemCard from "../common/ItemCard";
// import MyLearningCard from './MyLearningCard';
// import FavoriteCoursesListView from './FavoriteCoursesListView';
// import "../Course/CourseGrid.css";
// const FavoriteCourses = () => {
//   const [favorites, setFavorites] = useState([]);

//     const fetchFavorites = async () => {
//         const response = await courseService.getFavorites();
//         return {
//           data:{
//             favorites:response.data.favorites
//           }
//         }
//         // setFavorites(response.data.favorites || []);
      
//     };



//   // return (
//   //  <div className="favorite-courses-container">
//   //   {favorites.length > 0 ? (
//   //     favorites.map((course) => (
//   //       <div key={course.id}>
//   //         <ItemCard item={course} itemType="course" />
//   //       </div>
//   //     ))
//   //   ) : (
//   //     <p>No favorite courses found.</p>
//   //   )}
//   // </div>
//   // );


  


// };

// export default FavoriteCourses;

import React from "react";
import { courseService } from "../../services/api";
import ItemGrid from "../common/ItemGrid";
import FavoriteCoursesCard from "./FavoriteCoursesCard";
import FavoriteCoursesListView from "./FavoriteCoursesListView";

const FavoriteCourses = () => {
 
  const fetchItems = async (page, limit, searchTerm, sortOrder) => {
    const response = await courseService.getFavorites({
    page,
    limit,
    search: searchTerm,
    sort: sortOrder,
  });


    return {
    data: {
      courses: response.data.favorites || [],
      pagination: response.data.pagination || null,
    },
  };
  };

  return (
    <ItemGrid
      title="My Favorite Courses"
      description="View your favorite courses."
      itemType="course"
      fetchItems={fetchItems}
      ItemCardComponent={FavoriteCoursesCard}
      ItemListComponent={FavoriteCoursesListView}
      createPermission={null}    
      authorFilterEnabled={false}
      showSortingFilter={true}     
      paginationEnabled={true}     
      searchEnabled={true}   
    />
  );
};

export default FavoriteCourses;

